import { Box, Typography } from "@mui/material";

export default function SubHeaderTwo({ title = `Welcome to your CDA${String.fromCodePoint(0x000ae)} Professional Portfolio` }) {
  return (
    <Box
      className="WelcomeMessage"
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Typography variant="h5" fontWeight="bold">
        {title}
      </Typography>
    </Box>
  );
}
